<template>
	<div :class="classes">
		<div class="user-card__avatar">
			<UserAvatar
				:user="user"
				:size="avatarSize"
				:style="avatarContainerStyle"
			/>
		</div>
		<div class="user-card__text">
			<div class="user-card__name">
				{{ user.displayName }}
			</div>
			<div
				class="user-card__email"
				v-if="( user.displayName !== user.email )">
				{{ user.email }}
			</div>
		</div>
	</div>
</template>

<script>
import UserAvatar from "./UserAvatar.vue";

export default {
	name: "UserCard",

	components: {
		UserAvatar,
	},

	props: {
		avatarContainerStyle: {
			type: String,
			default: "",
		},
		avatarSize: {
			type: String,
			default: "2rem", // 24px
		},
		className: {
			type: String,
			default: "",
		},
		user: {
			type: Object,
			default() {
				return {};
			},
		},
	},

	computed: {
		classes() {
			return {
				"user-card": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.user-card {
	display: flex;
	align-items: center;

	@include for-size('xs') {
		max-width: 10rem;
	}
}

.user-card__text {
	text-align: left;
	margin-left: .5rem;
}

.user-card__name {
	@include font-and-line-for(0);
	font-weight: 600;
	color: $user-card-name-color;

	@include for-size('xs') {
		max-width: 8rem;
		width: 8rem;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
}

.user-card__email {
	@include font-and-line-for(0);
	color: $user-card-email-color;

	@include for-size('xs') {
		max-width: 8rem;
		width: 8rem;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
}
</style>
